import React, { useContext } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import BatchErrorsGrid from '../../../../BatchErrorsGrid';
import BatchContext from '../../BatchContext';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import { FormattedMessage } from 'react-intl';
import translations from './translations';

const BatchErrors = () => {
  const intl = useIntl();
  const { batch, shouldReloadErrors, setShouldReloadErrors } = useContext(BatchContext);

  return (
    <Card>
      <CardContent>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
        />
        {batch?.is_failing && (
          <Box mb={2}>
            <Alert severity="error">
              <FormattedMessage {...translations.feedback.failedJobNotice} />
            </Alert>
          </Box>
        )}
        <BatchErrorsGrid
          batchId={batch?.id}
          shouldReloadErrors={shouldReloadErrors}
          onReloadErrors={() => setShouldReloadErrors(false)}
        />
      </CardContent>
    </Card>
  );
};

export default BatchErrors;
